export const sortData = (arr, property) =>
  arr ? arr.sort((a, b) => b[property] - a[property]) : [];
